// @ts-check
import { defineConfig } from '../utils';

export function dumping() {
  return defineConfig({
    properties: {
      'Volcado.LecturaCodigoBarrasPorDefecto': {
        defaultValue: false,
      },
      'Volcado.ConfirmacionAntesDeVolcar': {
        defaultValue: true,
      },
      'Volcado.VolcarPorLecturaNFC': {
        defaultValue: false,
      },
      'Volcado.VolcarPorLecturaNFCTrabajarConIdInverso': {
        defaultValue: false,
      },
      'Volcado.LineaProduccionEstablecidaPorDefecto': {
        /** @type {import('@erpagroapp/types').LineaProduccion | null} */
        defaultValue: null,
      },
      'Volcado.PuntoVolcadoEstablecidoPorDefecto': {
        /** @type {import('@erpagroapp/types').PuntoVolcado | null} */
        defaultValue: null,
      },
    },
  });
}
